
import axios from 'axios';
import {
    PROVISION_SESSION_REQUEST,
    PROVISION_SESSION_SUCCESS,
    PROVISION_SESSION_FAIL,
    CLEAR_VIDEO_STATE,
    SET_USER_ROLE,
    baseURL,
    serviceUrl
} from './types';

export const setUserRole = (role) => ({
    type: SET_USER_ROLE,
    payload: role
});

export const provisionVideoSession = (payload) => async (dispatch) => {
    console.log("PROVISION_SESSION_REQUEST dispatched (Doctor - Initiate New Room)");
    dispatch({ type: PROVISION_SESSION_REQUEST });
    try {
        const token = localStorage.getItem('token');
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        };

        console.log("Making API call to initiate endpoint with payload:", payload);
        const { data } = await axios.post(
            `${serviceUrl}/api/appointmentvideocall/initiate`,
            payload,
            config
        );

        console.log("API response:", data.token);

        if (data.token && data.roomName) {
         
            console.log("Dispatching PROVISION_SESSION_SUCCESS (New Room)");
            localStorage.setItem(`twilioToken_${data.roomName}`, data.token);
            localStorage.setItem('twilioRoomName', data.roomName.toString());
            localStorage.setItem(`twilioRoom_${data.roomName}`, data.roomName.toString());
            console.log("✅ Token, roomName, and appointment-room association stored in localStorage");

            dispatch({
                type: PROVISION_SESSION_SUCCESS,
                payload: {
                    token: data.token,
                    roomName: data.roomName.toString(),
                },
            });
            dispatch(setUserRole('doctor'));
        } else {
            throw new Error(data.message || 'Failed to retrieve video token or room name.');
        }
    } catch (error) {
        console.error("PROVISION_SESSION_FAIL error during initiate:", error);
        dispatch({
            type: PROVISION_SESSION_FAIL,
            payload: error.response?.data?.message || error.message,
        });
    }
};

export const doctorRejoinSession = (payload) => async (dispatch) => {
    console.log("DOCTOR_REJOIN_SESSION_REQUEST dispatched");
    dispatch({ type: PROVISION_SESSION_REQUEST });
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      };
  
      console.log("Making API call to doctorjoin endpoint with payload:", payload);
      const { data } = await axios.post(
        `${serviceUrl}/appointmentvideocall/doctorjoin`,
        payload,
        config
      );
  
      console.log("API response:", data);
  
      if (data.token && data.roomName) {
        console.log("Dispatching PROVISION_SESSION_SUCCESS (Doctor Rejoin)");
  
        localStorage.setItem(`twilioToken_${payload.appointmentId}`, data.token);
        localStorage.setItem('twilioRoomName', data.roomName.toString());
        localStorage.setItem(`twilioRoom_${payload.appointmentId}`, data.roomName.toString());
           console.log("✅ Token, roomName, and appointment-room association stored in localStorage");
  
        dispatch({
          type: PROVISION_SESSION_SUCCESS,
          payload: {
            token: data.token,
            roomName: data.roomName.toString(),
          },
        });
        dispatch(setUserRole('doctor'));
      } else {
        throw new Error(data.message || 'Failed to retrieve video token or room name.');
      }
    } catch (error) {
      console.error("PROVISION_SESSION_FAIL error during doctor rejoin:", error);
      dispatch({
        type: PROVISION_SESSION_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const patientGenerateToken = (payload) => async (dispatch) => {
    console.log("PROVISION_SESSION_REQUEST dispatched (Patient Generate Token)"); // Changed log message
    dispatch({ type: PROVISION_SESSION_REQUEST });
    try {
        const token = localStorage.getItem('token');
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        };

        console.log("Making API call to patientjoin endpoint with payload:", payload);
        const { data } = await axios.post(
            `${serviceUrl}/api/appointmentvideocall/patientjoin`,
            payload,
            config
        );

        console.log("API response:", data);

        if (data.token && data.roomName) {
            console.log("Dispatching PROVISION_SESSION_SUCCESS (Patient Join)");

            localStorage.setItem(`twilioToken_${payload.appointmentId}`, data.token);
            localStorage.setItem('twilioRoomName', data.roomName.toString());
            localStorage.setItem(`twilioRoom_${payload.appointmentId}`, data.roomName.toString());
              console.log("✅ Token, roomName, and appointment-room association stored in localStorage for patient join");

            dispatch({
                type: PROVISION_SESSION_SUCCESS,
                payload: {
                    token: data.token,
                    roomName: data.roomName.toString(),
                },
            });
            dispatch(setUserRole('patient')); // Patient is joining, so role is patient
        } else {
            throw new Error(data.message || 'Failed to retrieve video token or room name.');
        }
    } catch (error) {
        console.error("PROVISION_SESSION_FAIL error during patient join:", error);
        dispatch({
            type: PROVISION_SESSION_FAIL,
            payload: error.response?.data?.message || error.message,
        });
    }
};

export const clearVideoState = (options = { clearStorage: true, appointmentId: null }) => {
  return (dispatch) => {
    if (options.clearStorage) {
      console.log("🧹 Cleared generic token and roomName from localStorage");

      if (options.appointmentId) {
        console.log(`🗑️ Immediately removing appointment data for ${options.appointmentId}`);
        
        localStorage.removeItem(`twilioRoom_${options.appointmentId}`);
        localStorage.removeItem(`twilioToken_${options.appointmentId}`);
        localStorage.removeItem(`twilioRoomName_${options.appointmentId}`);
      }
      
      // Remove generic items
      localStorage.removeItem('twilioToken');
      localStorage.removeItem('twilioRoomName');
      localStorage.removeItem(`twilioRoom_${options.appointmentId}`);

    } else {
      console.log("ℹ️ Skipping generic localStorage clearance as requested");
    }
    
    dispatch({
      type: CLEAR_VIDEO_STATE,
    });
  };
};



// // Add these helper functions to your videoActions.js

// // Get video session by appointment ID
// export const getVideoSessionByAppointmentId = async (appointmentId) => {
//   try {
//     const token = localStorage.getItem('token');
//     const config = {
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${token}`,
//       },
//     };
    
//     const response = await axios.post(
//       `${baseURL}/api/appointmentVideoSessions/room_name`,
//       {"room_name": appointmentId},
//       config
      
//     );
    
//     if (response.data.success) {
//       console.log(response.data.data)
//       return response.data.data
//     }
//     return null;
//   } catch (error) {
//     console.error("Error fetching video sessions:", error);
//     return null;
//   }
// };

// // Create a new video session
// export const createVideoSession = async (sessionData) => {
//   try {
//     const token = localStorage.getItem('token');
//     const config = {
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${token}`,
//       },
//     };
    
//     const response = await axios.post(
//       'http://3.27.121.21:3331/api/appointmentVideoSessions/create',
//       sessionData,
//       config
//     );
    
//     return response.data.success;
//   } catch (error) {
//     console.error("Error creating video session:", error);
//     return false;
//   }
// };

// // Update an existing video session
// export const updateVideoSession = async (sessionData) => {
//   try {
//     const token = localStorage.getItem('token');
//     const config = {
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${token}`,
//       },
//     };
    
//     const response = await axios.patch(
//       'http://3.27.121.21:3331/api/appointmentVideoSessions/update',
//       sessionData,
//       config
//     );
    
//     return response.data.success;
//   } catch (error) {
//     console.error("Error updating video session:", error);
//     return false;
//   }
// };










export const getRecUrl = async (hospitalID) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    
    const response = await axios.post(
      `${baseURL}/api/hospitalevideocallsessions/getall`,
    {hospitalID},
      config
      
    );
    
    if (response.data.success) {
      console.log(response.data.data)
      return response.data.data
    }
    return null;
  } catch (error) {
    console.error("Error fetching video sessions:", error);
    return null;
  }
};